























import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import moment from "moment";
import {
  ScheduledPersonalContribution,
  ContributionScheduleType
} from "@/shared/types";
import { useThemeStore } from "@/shared/store/theme";

@Component
export default class SchedulePersonalContributionConfirmModal extends Vue {
  themeStore = useThemeStore();

  @Prop({ required: true })
  confirmModalVisible: boolean;

  @Prop()
  scheduledPersonalContribution: ScheduledPersonalContribution;

  @Prop()
  linkedAccountName: string;

  onCancel (): void {
    this.$emit("cancel");
  }

  onSubmit (): void {
    this.$emit("confirm");
  }

  get formattedStartingDateCopy (): string {
    return moment(this.scheduledPersonalContribution.dateScheduledStart).format("MMMM DD, YYYY");
  }

  get contributionScheduleTypeDisplayCopy (): string {
    switch (this.scheduledPersonalContribution.contributionScheduleType) {
      case ContributionScheduleType.FirstOfMonth: {
        return "1st of every month";
      }
      case ContributionScheduleType.LastOfMonth: {
        return "last day of every month";
      }
      case ContributionScheduleType.FirstAndMiddleOfMonth: {
        return "1st and 15th of every month";
      }
      default: {
        return "none";
      }
    }
  }
}
